// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectAreaPageLoading,
  selectAreaShowInitWaitingMessage,
  selectAreasInStore,
} from '../_selectors/area.selectors';

export class AreaDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectAreaPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectAreaShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectAreasInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
